import { relatedJobsConfig } from '@scripts/frontend/elastic';
import React from 'react';
import { ErrorBoundary, SearchProvider, WithSearch } from '@elastic/react-search-ui';
import { Layout } from '@elastic/react-search-ui-views';
import { ElasticResultsWrapper } from '@scripts/frontend/job-listing/components/job/ElasticResultsWrapper';

interface Props {
  numberToShow: string;
  jobId?: string;
}

const RelatedJobsMain = ({ numberToShow, jobId }: Props) => {
  const config = relatedJobsConfig(numberToShow, jobId);

  return (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={() => ({})}>
        {() => (
          <ErrorBoundary>
            <Layout
              bodyContent={
                <ElasticResultsWrapper />
              }
            />
          </ErrorBoundary>
        )}
      </WithSearch>
    </SearchProvider>
  );
};

export default RelatedJobsMain;
